// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__20gu9","module":"Sidebar_module__WydiB"};